import { format } from 'date-fns';
import { ar } from 'date-fns/locale';
import en from 'date-fns/locale/en-US';
import es from 'date-fns/locale/es';
import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';

import { NextImage, Typography } from '@/shared/components/atoms';
import { formatAccountingPeriod } from '@/shared/components/molecules/CreateSettlement/logic';
import { useAuth } from '@/shared/hooks/context/auth';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { clsxm } from '@/shared/lib';

interface Props {
  issuanceDate?: string;
  workerName?: string;
  supplierName: string;
  startDate: string;
  endDate: string;
}
interface CardColumnProps {
  label: string;
  value?: string;
  labelBold?: boolean;
  valueBold?: boolean;
}

const CardColumn = ({
  label,
  value,
  labelBold,
  valueBold = true,
}: CardColumnProps) => (
  <div className='flex flex-1 flex-col items-start'>
    <Typography
      variant={labelBold ? 'body2' : 'caption'}
      weight={labelBold ? 'bold' : 'regular'}
    >
      {label}
    </Typography>
    <Typography
      variant={valueBold ? 'body2' : 'caption'}
      weight={valueBold ? 'bold' : 'regular'}
    >
      {value}
    </Typography>
  </div>
);
const Header: FC<Props> = ({
  issuanceDate,
  supplierName,
  workerName,
  startDate,
  endDate,
}) => {
  const { query, locale } = useRouter();
  const { id } = query;
  const [selectedAsset] = useStore((store) => store?.asset);
  const { user } = useAuth();

  const {
    t,
    i18n: { language },
  } = useTranslation('common');
  const classes = clsxm('flex items-center justify-between gap-2 py-16 px-1', {
    // ['flex-row-reverse']: language === 'ar',
  });
  return (
    <div className={classes}>
      {/* issuance date */}
      <CardColumn
        labelBold
        valueBold={false}
        label={`${t('settlement')} ${id}`}
        value={`${t('issuing-date')} : ${format(
          new Date(issuanceDate || ''),
          'd MMMM yyyy',
          {
            locale: locale === 'ar' ? ar : locale === 'es' ? es : en,
          }
        )}`}
      />
      <CardColumn label={t('farm')} value={selectedAsset?.name} />
      {workerName ? <CardColumn label={t('worker')} value={workerName} /> : ''}
      <CardColumn
        label={t(workerName ? 'crew' : 'team_leader')}
        value={supplierName}
      />
      <CardColumn
        label={t('accounting-period')}
        value={formatAccountingPeriod({ startDate, endDate, language })}
      />
      {user?.companyLogo && (
        <div className='flex h-full w-full flex-1 justify-end'>
          <NextImage
            priority
            fill
            useSkeleton
            src={user?.companyLogo}
            alt='company logo'
            className='h-32 w-56'
          />
        </div>
      )}
    </div>
  );
};
export default Header;
